import { Button } from 'antd';
import React, { useState } from 'react';
import { UserOutlined } from '@ant-design/icons';
import { Avatar, Space, Typography } from 'antd';
import {
  BaseCustomModal,
  useBaseCustomModalManager,
  BaseCustomButton,
  CustomNotificationModal,
  GradientDecorationLine,
  BaseCustomTextArea,
  BaseCustomDropdownMenu
} from '../../shared';

/**
 * This page is for development purposes only.
 * It contains examples of the shared components.
 * @returns {JSX.Element} The JSX code for the DevPageView component.
 */
export const DevPageView = () => {
  const [counter, setCounter] = useState(0);

  // Initializa the hook inside the parent component
  const {
    showModal,
    handleOk,
    handleCancel,
    isModalOpen
  } = useBaseCustomModalManager();

  // We defined our children component here!
  const children = (counter) => (
    <React.Fragment>
      <p>Some contents...</p>
      <p>Some contents...</p>
      <p>Some contents...</p>
      <h1>This is my counter: {counter}</h1>
    </React.Fragment>
  );

  const onClickOpenModal = () => {
    showModal();
    setCounter(counter + 1);
  };

  const [text, setText] = useState('');

  const { Paragraph } = Typography;

  const handleDropdownClick = ({ key }) => {
    switch (key) {
      case 'log-out':
        CustomNotificationModal({ type: 'info', title: 'Info', children: <p>Cerraste sesión (en realidad no, es una demo).</p> });
        break;
      case 'link':
        break;
      case 'danger-item':
        CustomNotificationModal({ type: 'error', title: 'Error', children: <p>¡This a danger item!</p> });
        break;
      default:
        CustomNotificationModal({ type: 'info', title: 'Info', children: <p>Click on dropdown item {key}</p> });
    }
  }

  return (<React.Fragment>
    <div className='page-content'>
      <div className='container'>

        <div className='row'>
          <div className='col-12'>

            <h1>Development Page for Testing</h1>
            <GradientDecorationLine />

            <Paragraph>
              <pre className='blockquote mt-5'>
                <p className='mb-0'>This page is for development purposes only.
                  It contains examples of the shared components. The components are
                  reusable and can be used in any part of the application. The components are based on <a href="https://ant.design/components/overview/">Ant Design Components</a>.
                </p>
              </pre>
            </Paragraph>

            <section className='my-5'>
              <h2 className='mb-3'>Base Custom Modal</h2>
              <Button type="primary" onClick={onClickOpenModal}>
                Open Modal
              </Button>
              <BaseCustomModal
                title="Development Modal!"
                isModalOpen={isModalOpen}
                handleOk={handleOk}
                handleCancel={handleCancel}
                children={children(counter)}
              />
            </section>

            <hr />

            <section className='my-5'>
              <h2 className='mb-3'>Custom Buttons</h2>
              <div className="row justify-content-center">
                {/* Cancel Button */}
                <div className="col-12 col-md-4 col-lg-3">
                  <BaseCustomButton
                    outline
                    className='mt-1'
                    color="danger"
                    icon="mdi-close-circle-outline"
                    label="Cancelar"
                    onClick={console.log('Cancel Button Clicked!')}
                  ></BaseCustomButton>
                </div>
                {/* New Register Button */}
                <div className="col-12 col-md-4 col-lg-3">
                  <BaseCustomButton
                    color="success"
                    className='mt-1'
                    icon="mdi-plus"
                    label="Nuevo Registro"
                    onClick={console.log('New Register Button Clicked!')}
                  ></BaseCustomButton>
                </div>
                {/* Back Button */}
                <div className="col-12 col-md-4 col-lg-3">
                  <BaseCustomButton
                    outline
                    className='mt-1'
                    color="success"
                    icon="mdi-arrow-left"
                    label='Regresar'
                    onClick={console.log('Back Button Clicked!')}
                  ></BaseCustomButton>
                </div>
                {/* Service Request Button */}
                <div className="col-12 col-md-4 col-lg-3">
                  <BaseCustomButton
                    className='btn btn-info py-2 w-23 rounded-3 mt-1'
                    icon="mdi mdi-plus me-2"
                    label='Solicitud de servicio'
                    onClick={console.log('Service Request Button Clicked!')}
                  ></BaseCustomButton>
                </div>
                {/* Search Button */}
                <div className="col-12 col-md-4 col-lg-3">
                  <BaseCustomButton
                    className='btn btn-dark py-2 rounded-3 w-100 mt-1'
                    icon="mdi mdi-magnify me-2"
                    label='Buscar'
                    onClick={console.log('Search Button Clicked!')}
                  ></BaseCustomButton>
                </div>
                {/* Ema Acreditation Button */}
                <div className="col-12 col-md-4 col-lg-3">
                  <BaseCustomButton
                    className='btn btn-primary w-100 rounded-pill px-5 mt-1'
                    label="Acreditación ema"
                    onClick={console.log('Ema Acreditation Button Clicked!')}
                  ></BaseCustomButton>
                </div>
                {/* save Button */}
                <div className="col-12 col-md-4 col-lg-3">
                  <BaseCustomButton
                    outline
                    className='rounded-3 mt-1'
                    icon="mdi mdi-content-save me-2"
                    label='Guardar'
                    onClick={console.log('Save Button Clicked!')}
                  ></BaseCustomButton>
                </div>
                {/* Table Button */}
                <div className="col-12 col-md-4 col-lg-3">
                  <BaseCustomButton
                    className='btn btn-info py-1 rounded-3 mt-1'
                    label="Tabla"
                    icon='mdi mdi-18px mdi-table me-2'
                    onClick={console.log('Table Button Clicked!')}
                  ></BaseCustomButton>
                </div>
              </div>
            </section>

            <hr />

            <section className='my-5'>
              <h2 className='mb-3'>Custom Notification Modals</h2>
              <div>
                <BaseCustomButton color="info" label="Info" onClick={() => CustomNotificationModal({ type: 'info', title: 'Info', children: <p>This is an info message.</p> })} />
                <BaseCustomButton className='mx-2' color="success" label="Success" onClick={() => CustomNotificationModal({ type: 'success', title: 'Success', children: <p>Operation successful!</p> })} />
                <BaseCustomButton className='mx-2' color="danger" label="Error" onClick={() => CustomNotificationModal({ type: 'error', title: 'Error', children: <p>Something went wrong.</p> })} />
                <BaseCustomButton className='mx-2' color="warning" label="Warning" onClick={() => CustomNotificationModal({ type: 'warning', title: 'Warning', children: <p>Please check your input.</p> })} />
              </div>
            </section>

            <hr />

            <section className="my-5">
              <h2 className="mb-3">Custom Dropdown Menu</h2>
              <div className="row align-items-center justify-content-between">
                <BaseCustomDropdownMenu
                  items={[
                    {
                      key: '1',
                      label: 'Menu item 1 (disabled)',
                      disabled: true
                    },
                    {
                      type: 'divider',
                    },
                    {
                      key: '2',
                      label: 'Menu item 2 (enabled)',
                    },
                    {
                      key: '3',
                      label: 'Menu item 3 (with extra)',
                      extra: '⌘S'
                    },
                    {
                      key: '4',
                      label: 'Menu item 4 (with icon)',
                      icon: <span className='mdi mdi-cog'></span>,
                      extra: '⌘S'
                    },
                    {
                      key: 'danger-item',
                      danger: true,
                      label: 'A danger item',
                    },
                    {
                      key: 'link',
                      label: (
                        <a target="_blank" rel="noopener noreferrer" href="https://ant.design/components/dropdown#dropdown-demo-extra">
                          A link to something
                        </a>
                      ),
                    },
                  ]}
                  toggleElement="Open Basic Dropdown Menu"
                  className='col-12 col-md-6 col-lg-4 col-xl-3 mb-4'
                  onClick={handleDropdownClick}
                />
                <BaseCustomDropdownMenu
                  items={[
                    {
                      key: '1',
                      label: 'Profile',
                      icon: <span className='mdi mdi-account'></span>,
                      disabled: true
                    },
                    {
                      type: 'divider',
                    },
                    {
                      key: '2',
                      label: `Item 2`,
                    },
                  ]}
                  children={
                    <BaseCustomButton
                      color='primary'
                      outline
                      label='Open Button Dropdown Menu'
                    />
                  }
                  className='col-12 col-md-6 col-lg-4 col-xl-3 mb-4'
                  onClick={handleDropdownClick}
                />
                <BaseCustomDropdownMenu
                  items={[
                    {
                      key: '1',
                      label: `Hola, username here`,
                      disabled: true
                    },
                    {
                      type: 'divider',
                    },
                    {
                      key: '2',
                      label: `Rol: role here`,
                      disabled: true
                    },
                    {
                      key: '3',
                      label: `Email: example@holcim.com`,
                      disabled: true
                    },
                    {
                      type: 'divider',
                    },
                    {
                      key: 'log-out',
                      label: "Cerrar Sesión",
                      icon: <i className="uil uil-sign-out-alt font-size-18 align-middle me-1 text-muted"></i>,
                    },
                  ]}
                  toggleElement={
                    <Space>
                      <Avatar size="large" icon={<UserOutlined />} />
                      <span className='fw-medium font-size-15'>Username here</span>
                    </Space>
                  }
                  className='col-12 col-md-6 col-lg-4 col-xl-3 mb-4'
                  placement="bottomLeft"
                  onClick={handleDropdownClick}
                // trigger={['click']}   //? Uncomment to use click instead of hover
                />
              </div>
            </section>

            <hr />

            <section className="my-5">
              <h2 className="mb-3">Custom Text Area</h2>

              <label className='text-primary'>Uncontrolled TextArea</label>
              <p>Type as much as you want</p>
              <BaseCustomTextArea
                placeholder="Autosize height based on content lines"
                className='mb-3'
                autoSize
              />

              <label className='text-primary'>Partially controlled TextArea</label>
              <p>After 6  rows a scrollbar appears</p>
              <BaseCustomTextArea
                placeholder="Autosize height with minimum and maximum number of lines"
                autoSize={{ minRows: 2, maxRows: 6 }}
                className='mb-3'
              />

              <label className='text-primary'>Controlled TextArea</label>
              <p>After 4  rows a scrollbar appears</p>
              <BaseCustomTextArea
                value={text}
                onChange={(e) => setText(e.target.value)}
                placeholder="Controlled size, maximum 12 characters in 4 rows"
                rows={4}
                maxLength={12}
              />
            </section>
          </div>
        </div>
      </div>
    </div>
  </React.Fragment>);
};